import ArkLoader from '@src/js/common/ark-extensions';
import aiAssistant from './component-config';
import { IAIAssistantExtension } from './type';

export async function getAiAssistant(): Promise<IAIAssistantExtension> {
    const arkService = ArkLoader.extensionService;
    await arkService.scanAndHandleExtensions([aiAssistant]);
    const aiComponent = await ArkLoader.extensionService.getExtension(aiAssistant.name) as IAIAssistantExtension;
    return aiComponent;
}
